import React from "react";
import ProductDetail from "../../components/ProductDetail";
import ReactPlayer from "react-player";
import useFetch from "../../hooks/useFetch";
import './index.css'

const urls = [`detail/1`, `detail/2`, `detail/3`, `detail/4`];

const ProductCenter = () => {
  const responseData = useFetch("http://1.94.62.64:9090/myf/products/detail");

  return (
    <div className="flex flex-col items-center">
      <div className="product-bg-image flex justify-center items-center space-x-4 h-[500px] w-screen" />
      <div className="mt-14 mb-5 bg-slate-200 rounded-lg w-[1200px]">
        <ReactPlayer
          controls
          width={1200}
          height={600}
          url='http://1.94.62.64:9090/myf/video2/prodect_center'
        />
      </div>
      <div className="grid grid-cols-3 my-20">
        {responseData && responseData?.map((item, idx) => {
          return (
            <ProductDetail
              key={idx}
              imgSrc={item.picture}
              header={item.name}
              text={item.msg}
              pathUrl={urls[idx]}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProductCenter;
